import { logo } from "assets/icons";
import { useNavigate } from "react-router-dom";
import { HOME_PATH } from "Routes/paths";
import { useTranslation } from "react-i18next";

interface ErrorPathPageProps {}

const ErrorPathPage = ({}: ErrorPathPageProps) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  return (
    <main
      className={`${
        i18n.language === "en" ? "font-Poppins" : "font-Almarai"
      } w-full h-screen flex flex-col items-center justify-center gap-8`}
    >
      <div>
        <img
          onClick={() => navigate(HOME_PATH)}
          className="cursor-pointer w-52 md:w-96"
          src={logo}
          alt=""
        />
      </div>
      <h1 className="text-first_color text-3xl md:text-6xl font-[800]">
        Page Not found!
      </h1>
      <h1 className="text-first_color text-3xl md:text-6xl font-[800]">404</h1>

      <div>
        <button
          onClick={() => navigate(HOME_PATH)}
          className="w-[200px] h-[50px] md:w-[300px] md:h-[60px] bg-first_color text-white text-sm md:text-lg font-[600px] rounded-xl hover:bg-first_color/85 duration-300"
        >
          Go to home page
        </button>
      </div>
    </main>
  );
};

export default ErrorPathPage;
